import React, { useContext } from 'react';
import img from '../../../assets/Img'; // تأكد من وجود img.crm داخل هذا المسار
import { LocalizationContext } from '../../../context/LangChange';
import { Col, Row } from 'react-bootstrap';
import '../seo.css';
const translations = {
  en: require('../../../Translate/en.json').WebsiteDevelopment2.CustomCMS,
  ar: require('../../../Translate/ar.json').WebsiteDevelopment2.CustomCMS,
};

const CustomCMS = () => {
  const { isLang } = useContext(LocalizationContext);
  const t = translations[isLang || 'en'];

  return (
    <div className="custom-cms-container">
      <Row dir={isLang === 'ar' ? 'rtl' : 'ltr'}>
        <Col md={7} lg={7} sm={12}>
          <div className="content_crm">
            <h2 className="custom-cms-title" style={{ color: '#F15926' }}>{t.title}</h2>
            <h3 className="custom-cms-subtitle" style={{ fontWeight: 'bold' }}>{t.subtitle}</h3>
            <p className="custom-cms-description my-4">{t.description}</p>
          </div>
        </Col>

        <Col md={7} lg={5} sm={12}>
          <div className="image-container">
            <img
              width={500}
              height={300}
              src={img.Crm}
              alt="Custom CMS Image"
              className="w-100 h-full"
            />
          </div>
        </Col>

        <Col md={12} lg={12} sm={12}>
          <div className="content_crm mt-4">
            <h4 className="advantages-title" style={{ fontWeight: 'bold' }}>{t.advantagesTitle}</h4>
            <ul className="custom-cms-advantages mt-4">
              {t.advantages.map((advantage, index) => {
                const [title, desc] = advantage.split(':');
                return (
                  <li key={index}>
                    <span className="advantage-number">{index + 1} - </span>
                    <strong>{title.trim()}:</strong> {desc.trim()}
                  </li>
                );
              })}
            </ul>
          </div>
        </Col>
      </Row>
    </div>
  );
};

export default CustomCMS;
